import * as React from "react";
import { IWithHistoryProp, withHistory } from "../../../../shared/hoc/with-history";
import KuikaMenuItem from "../../../ui-kit/kuika-menu-item/kuika-menu-item";
import KuikaSvg from "../../../ui-kit/kuika-svg/kuika-svg";

export interface ICloudLeftPanelProps {
  url?: string;
}

class CloudLeftPanelBase extends React.PureComponent<ICloudLeftPanelProps & IWithHistoryProp> {
  render() {
    return (
      <div className="kuika-projects__left-panel">
        <div>
          <KuikaMenuItem
            title="Domains"
            selected={this.props.url === "domains" || this.props.url === "cloud"}
            onClick={() => this.props.navigator.gotoCloudDomains()}
            leftIcon={<KuikaSvg name="world-www" />}
          />
          <KuikaMenuItem
            title="Deployments"
            selected={this.props.url === "deployments"}
            onClick={() => this.props.navigator.gotoCloudDeployments()}
            leftIcon={<KuikaSvg name="rocket" />}
          />
        </div>
      </div>
    );
  }
}

const CloudLeftPanel = withHistory<ICloudLeftPanelProps>(CloudLeftPanelBase);
export { CloudLeftPanel };
